import {
  Component, OnInit, Input, OnChanges, SimpleChanges, ElementRef, ViewEncapsulation
  , ViewChild, AfterViewInit, Output, EventEmitter, ViewContainerRef, TemplateRef, OnDestroy
} from '@angular/core';

import { SupervisionError, Supervision, Site, Flight } from 'solar-bo';
import { MapSupervisionHelper } from '@solar/ol';
import { SolarService } from '../services/solarservice.service';
import { SolarBaseComponent } from '@solar/solar/solar-base';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { Subscription, fromEvent } from 'rxjs';
import { TemplatePortal } from '@angular/cdk/portal';
import { filter, take } from 'rxjs/operators';
import { ErrorcontrolService } from 'basecomponents';
import { SortHelper } from 'shtools';
import { ImageItem } from 'solar-bo';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { ImageThermalComponent } from '../supervis/imagethermal/imagethermal.component';
import { DBG, DebugLevelEnum } from '@solar/shared/dbg.model';



@Component({
  selector: 'app-imagethumbgallery',
  templateUrl: './imagethumbgallery.component.html',
  styleUrls: ['./imagethumbgallery.component.scss']
  , encapsulation: ViewEncapsulation.None
})
export class ImageThumbGalleryComponent extends SolarBaseComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {

  TAG="ImageThumbGalleryComponent"
  @Input() load_type: string = "FLIGHT";//OTHER TYPES "ISSUES"
  @Input() flights: Flight[] = [];
   showLabels = true;
  imageCount=0;
  /**
   * To show the number of images 
   */
  imagesCountDesc:string="";

  _selectedIndex: number = 0;
  @Input() set selectedIndex(value: number) {
    this._selectedIndex = value;
  }
  get selectedIndex(): number {
    return this._selectedIndex;
  }
  @Input() clickable: boolean = true;

  _supervision: Supervision;
  @Input() set supervision(value: Supervision) {
    this._supervision = value;
    DBG.log(DebugLevelEnum.VERBOSE,this.TAG,"Input supervision",this.supervision);
    this.loadImagesBySupervision();
  }
  get supervision(): Supervision {
    return this._supervision;
  }

  @Input() issueList: SupervisionError[];
  @Input() issueSelected: SupervisionError;

  @Input() galleryImagesStore = [];
  private _galleryImagesStore_inter = [];
   
  // ahora hay que ordenar por vuelo e imagen ya que pueden hacer supervisiones con varios drones al miamo tiempo
  // ya no se puede ordenar por imagen asi que tenemos que almacenar los resultados mientras se reciben por que son peticiones asincronas y llegan desordenados
  private flightLoad:{id_flight:string, images:any[]}[]=[];


  /**
   * event emitted when click on thumb image
   */
  @Output() onThumbClick = new EventEmitter();
  /**
   * event emitted when right click on thumb image
   */
  @Output() onThumbRightClick: EventEmitter<{ gallery: any, imgDTO: ImageItem }> = new EventEmitter<{ gallery: any, imgDTO: ImageItem }>();
  @Output() onClose = new EventEmitter();

  @ViewChild('gallery') gallery: CdkVirtualScrollViewport;
  //context menu vars
  ctx_MouseEventSubscription: Subscription;
  @ViewChild('ctxMenu') ctxMenu: TemplateRef<any>;
  overlayRef: OverlayRef | null;

  constructor(public solarService: SolarService,
    public overlay: Overlay,
    public viewContainerRef: ViewContainerRef) {
    super();
  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    //console.log("IssuecanvasComponent ngOnChanges " ,changes);
    let typeChange = changes['imageUrlList'];
    if (typeChange && typeChange.currentValue != null) {
      if (this.load_type == "ISSUES") {
        //this.configureImagesByIssueList(typeChange.currentValue);
      }
    }
  }

  ngAfterViewInit() {
    //console.log("ngAfterViewInit this.gallery: " + this.gallery);
  }

  ngOnDestroy() {
    if (this.ctx_MouseEventSubscription) {
      this.ctx_MouseEventSubscription.unsubscribe();
    }
  }


  showHideByReload: boolean = true;
  loadImagesBySupervision(): void {
    if (!this._supervision) {
      return;
    }
    this.listerrmessage = "";
    this.loading = true;

    this.solarService.supervisionGetFlights(this.supervision.id)
      .subscribe(
        reslist => this.getSupervisionFlightsListhandleresult(reslist)
        , err => this.getListhandleError(err)
      );
  }

  private flightsLoadCount: number = 0;
  /**
   * Load all images for flights in list
   * @param newFlightlist 
   */
  private getSupervisionFlightsListhandleresult(newFlightlist: any[]) {
    this.listerrmessage = '';
    
    this.flights = SortHelper.sortMultiple(newFlightlist, ["info.creation_date"], ["asc"]);
    for (let flight of this.flights){   
      console.log("Flight " + flight.name);   
      this.flightLoad.push({id_flight:flight.id, images:[]})
    }
    console.log("flights=", this.flightLoad);
    
    DBG.log(DebugLevelEnum.VERBOSE,this.TAG,"getSupervisionFlightsListhandleresult newFlightlist: ",newFlightlist);
    this.alertmessage = null;
    //get images for each flight
    for (let flg of this.flights) {
      this.loading = true;
      this.loadFlightImages(flg);
    }
    this.loading = false;
  }
  private getListhandleError<T>(err: any) {
    console.log("getListhandleError");
    this.loading = false;
    this.alertmessage = ErrorcontrolService.basichandleError("", err);
  }

  /**
   * forma rapida de sincronizar las peticiones
   */
  private configureCaroussel() {
    if (this.flightsLoadCount != this.flights.length) {
      return;
    }
    //this._galleryImagesStore_inter = SortHelper.sortMultiple(this._galleryImagesStore_inter, ["tag.image.time"], ["asc"])
    for (let flightImg of this.flightLoad){
      let gal=flightImg.images;
      this._galleryImagesStore_inter = this._galleryImagesStore_inter.concat(gal);
    }
    
    this.galleryImagesStore = this._galleryImagesStore_inter;
    this.flightLoad=null;
    this._galleryImagesStore_inter = null;
  }

  private loadFlightImages(flight: Flight) {
    this.solarService.flightGetImagesCaroussel(flight.id)
      .subscribe(
        res_list => this.loadFlightImagesHandleresult(flight, res_list)
        , err => this.handleError(err)
      );
  }
  

  private async loadFlightImagesHandleresult(flight: Flight, newlist: any[]) {
    this.flightsLoadCount += 1;
    this.showHideByReload = true;
    DBG.log(DebugLevelEnum.VERBOSE,this.TAG,"loadFlightImagesHandleresult flight/images ",flight,newlist);
    newlist = SortHelper.sortMultiple(newlist, ["tag.image.time"], ["asc"])
    let promise = this.configureImagesByFlight(flight, newlist);
    this.configureCaroussel();
    if (this.issueSelected) {
      this.selectImageByIssue(this.issueSelected);
    }
  }

  private async configureImagesByFlight(flight: Flight, list: any[]) {

    if (!list || list.length == 0) {
      return;
    }

    let gal = [];
    for (let img of list) {
      let url = this.flightimageBigUrl(img.name, this.supervision.site.id, this._supervision.id, flight.id);
      let urlThumb = this.flightImageThumbUrl(img.name, this._supervision.site.id, this._supervision.id, flight.id);
      let obj: ImageItem = {
        id: img.id
        , small: urlThumb
        , medium: url
        , big: url
        , description: img.name
        , label: img.name
        , tag: { flight: flight, image: img }
      };
      gal.push(obj);
    }
    let flighImg=this.flightLoad.find(item=>item.id_flight==flight.id)
    flighImg.images=gal 
    this.imageCount+=gal.length;   
    this.imagesCountDesc= this.imageCount + " images" ;
    this.showHideByReload = true;
    return true;
  }


  private getImageIndexByIssue(issueSelected: SupervisionError, list: any[]) {
    if (!list) {
      return -1;
    }
    //let imgName = issueSelected.image.name;
    //let url = this.flightimageBigUrl(imgName, issueSelected.supervision.site.id, issueSelected.supervision.id, issueSelected.flight.id);
    let index = list.findIndex(item => item.id === issueSelected.image.id);
    //console.log("getImageIndexByIssue internal index:" + index);
    return index;
  }

  selectImageByIssue(issueSelected: SupervisionError) {
    this.gallery_playflight_stop();//no importa si se encuentra o no, cancelamos el play
    const index = this.getImageIndexByIssue(issueSelected, this.galleryImagesStore);
    if (index != -1) {
      this.scrollToIndex(index);
      const item = this.galleryImagesStore[index];
      //this.onThumbClick.next({event:null,item:item,index:index});
      return item;
    }
    return null;
  }

  flightimageBigUrl(image_name: string, id_site: string, id_supervision: string, id_flight: string): string {
    return MapSupervisionHelper.issueUrlImgByFullFields(image_name, id_site, id_supervision, id_flight);
  }
  flightImageThumbUrl(image_name: string, id_site: string, id_supervision: string, id_flight: string): string {
    return MapSupervisionHelper.FlightImageThumbUrlByFullFields(image_name, id_site, id_supervision, id_flight);
  }
  /**
   * get the image object by index
   * @param index 
   */
  getImageItem(index: number): ImageItem {
    let lst = this.galleryImagesStore;

    if (index > -1 && index < lst.length) {
      return lst[index];
    }

    return null;
  }


  thumbOnRightClick($event, imageItem: ImageItem, index: number) {
    //console.log(imageItem);
    let itemDTO: any = { item: imageItem, actions: [] };
    itemDTO.actions.push({ description: 'New Issue from image ', action: this.issueAddFromImage.bind(this) });
    itemDTO.actions.push({ description: 'Show high resolution image', action: this.gallery_expandSelectedImage.bind(this) });
    this.ctx_open($event, itemDTO);
    return false;//to avoid show context
  }

  issueAddFromImage($event, itemDTO) {
    console.log($event, itemDTO);
    let imageItem: ImageItem = itemDTO.item;
    this.ctx_close();
    let dto: { gallery: any, imgDTO: ImageItem } = { gallery: this.galleryImagesStore, imgDTO: imageItem };
    this.onThumbRightClick.emit(dto);
    return false;//to avoid show context
  }


  ctx_open({ x, y }: MouseEvent, item) {
    try {
      this.ctx_close();
      const positionStrategy = this.overlay.position()
        .flexibleConnectedTo({ x, y })
        .withPositions([
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top',
          }
        ]);

      this.overlayRef = this.overlay.create({
        positionStrategy,
        scrollStrategy: this.overlay.scrollStrategies.close()
      });

      this.overlayRef.attach(new TemplatePortal(this.ctxMenu, this.viewContainerRef, {
        $implicit: item
      }));

      this.ctx_MouseEventSubscription = fromEvent<MouseEvent>(document, 'click')
        .pipe(
          filter(event => {
            const clickTarget = event.target as HTMLElement;
            return !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget);
          }),
          take(1)
        ).subscribe(() => this.ctx_close())
    }
    catch (error) {
      console.error(error);
    }
  }

  ctx_close() {
    this.ctx_MouseEventSubscription && this.ctx_MouseEventSubscription.unsubscribe();
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }

  /**
   * Show tooltip on image
   * @param imageItem 
   */
  imageDescriptionToolTip(imageItem: ImageItem) {
    let flight: Flight = imageItem.tag.flight;
    return "Flight: " + flight.name + " Img: " + imageItem.label;
  }
  /**
   * handles click on image
   * @param item 
   */
  thumbclick($event, item, index: number) {
    //console.log($event, item);
    this._selectedIndex = index;
    this.onThumbClick.next({ event: $event, item: item, index: index });

  }
  gallery_showImageOnMap(item:ImageItem,index:number) {
    this._selectedIndex = index;
    this.onThumbClick.next({ event: null, item: item, index: index });

  }  
  close() {
    this.onClose.next();
  }
  /**
   * Scroll gallery to selected index
   * @param index 
   * @param andSelect If false only move scroll
   */
  scrollToIndex(index,andSelect:boolean=true) {
    if (index < 0) {
      return;
    }
    this.gallery.scrollToIndex(index);
    if (andSelect){
      this._selectedIndex = index;
    }
    
  }

  gallery_expandSelectedImage() {
    this.ctx_close();
    if (this._selectedIndex == -1) {
      return;
    }

    let item = this.getImageItem(this._selectedIndex);
    if (!item) {
      return;
    }

    ImageThermalComponent.openModalForImage(this.dialog, this.supervision, item);
    return false;
  }

  gallery_expandSelectedImageByImageItem(item:ImageItem) {
    this.ctx_close();

    if (!item) {
      return;
    }

    ImageThermalComponent.openModalForImage(this.dialog, this.supervision, item);
    return false;
  }
  

  gallery_addissuefromindex(index:number) {
    this.ctx_close();
    if (index == -1) {
      return;
    }

    let item = this.getImageItem(index);
    if (!item) {
      return;
    }

    this.gallery_addissuefromimageitem(item);
  }

  gallery_addissuefromimageitem(item:ImageItem) {
    this.ctx_close();
    if (item == null) {
      return;
    }

    let dto: { gallery: any, imgDTO: ImageItem } = { gallery: this.galleryImagesStore, imgDTO: item };
    this.onThumbRightClick.emit(dto);
    return false;//to avoid show context
  }  

  gallery_addissue_fromselected() {
    this.gallery_addissuefromindex(this.selectedIndex);
    return false;

  }

  playGallery: boolean = false;
  playGallery_class = "fas fa-play";
  playGallery_class_stop = "fas fa-stop";
  async gallery_playflight() {
    if (this.playGallery == false) {
      this.playGallery = true;
      this.playGallery_class = "far fa-stop-circle text-danger";
    } else {
      this.playGallery = false;
      this.playGallery_class = "fas fa-play";
      return;
    }

    for (let idx = this._selectedIndex; idx < this.galleryImagesStore.length; idx++) {
      const item = this.galleryImagesStore[idx];
      await this.goto(idx, item);
      if (!this.playGallery) {
        return;
      }
    }
  }

  private gallery_playflight_stop() {
    this.playGallery = false;
    this.playGallery_class = "fas fa-play";
  }

  private async goto(idx, item) {
    return new Promise<any>(resolve =>
      setTimeout(resolve, 1000))
      .then(() => {
        if (!this.playGallery) {
          return;
        }
        this.scrollToIndex(idx);
        this.thumbclick(null, item, idx);
      }
      );
  }


  /**
   * The "callback" argument is called with either true or false
   *  depending on whether the image at "url" exists or not.
  * Sample usage
  var imageUrl = 'http://www.google.com/images/srpr/nav_logo14.png';
  imageExists(imageUrl, function(exists) {
    console.log('RESULT: url=' + imageUrl + ', exists=' + exists);
  });
   * @param url 
   * @param callback 
   */
  imageExists(url, callback) {
    var img = new Image();
    img.onload = function () { callback(true); };
    img.onerror = function () { callback(false); };
    img.src = url;
  }


  checkimage(url: string) {
    fetch(url, { method: 'HEAD' })
      .then(res => {
        if (res.ok) {
          console.log('Image exists.');
          return url;
        } else {
          console.log('Image does not exist.');
          return "https://prepro.geoaitech.com/images-supervision/3e23a072-581a-11ea-a413-509a4c837ab7/supervisions/e04d7c88-8fd3-11ea-8859-509a4c837ab7/output/thermal/images_rgb/e96404fe-8fd3-11ea-8859-509a4c837ab7/M16-F01-C39.jpg";
        }
      }).catch(err => console.log('Error:', err));

  }

  findimage_click_handler(imageName2Find) {
    if (imageName2Find == "") {
      return;
    }
    let idx = this.getImageIndexByName(imageName2Find);
    this.scrollToIndex(idx);
    const item = this.galleryImagesStore[idx];
    this.thumbclick(null, item, idx);
  }

  private getImageIndexByName(imgName) {
    let list = this.galleryImagesStore;
    if (!list) {
      return -1;
    }
    let index = list.findIndex(item => item.label === imgName);
    return index;
  }
}
